import React from "react";



export default function Blog(){
    return(
    <>
    <div className="section">  
    <div className="projects-title" id="projects">
            <h2><span class="material-symbols-outlined bullet2">square</span>Blogs</h2>
            <p className="blog-page">Blog page coming soon!</p>
        </div> 
    </div>
    </>
    )
}